var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllRounderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16648_138918)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2813 54.9524C6.01567 54.9524 4.75003 54.4251 3.80081 53.4759L1.48048 51.1555C0.531254 50.2063 0.00390625 48.9407 0.00390625 47.675C0.00390625 46.3039 0.531254 45.0383 1.48048 44.0891L30.2736 15.2959L30.3791 15.1904C30.4846 15.1904 30.5901 15.085 30.6955 15.085H31.0119C31.1174 15.1904 31.1174 15.1904 31.2229 15.1904C32.594 16.1397 34.387 16.0342 35.5471 14.9795C35.8635 14.6631 36.3909 14.6631 36.6018 14.9795L39.9768 18.3545C40.2933 18.5655 40.2933 19.0928 39.9768 19.4092C38.9221 20.5694 38.8167 22.3624 39.7659 23.7335C39.7659 23.8389 39.7659 23.8389 39.8714 23.9444V24.2608C39.8714 24.3663 39.8714 24.4717 39.7659 24.5772L39.6604 24.6827L10.8673 53.4759C9.91804 54.4251 8.6524 54.9524 7.2813 54.9524Z",
    fill: "url(#paint0_radial_16648_138918)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0234 13.503L49.4688 1.16309C49.7852 0.846679 50.2071 0.846679 50.5235 1.16309L53.7931 4.43264C54.1095 4.74905 54.1095 5.17093 53.7931 5.48734L41.4532 17.9327C41.3477 17.7218 41.1367 17.5109 41.0313 17.2999L37.6563 13.9249C37.4453 13.8194 37.2344 13.6085 37.0234 13.503Z",
    fill: "url(#paint1_radial_16648_138918)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0274 53.4767C36.8125 53.4767 34.7032 52.6329 33.2266 51.2618C35.125 49.5743 36.1797 47.254 36.1797 44.6172C36.1797 42.086 35.125 39.6602 33.2266 37.9727C34.8086 36.4961 36.918 35.7578 39.0274 35.7578C41.2423 35.7578 43.3517 36.6016 44.9337 37.9727C42.9298 39.6602 41.8751 42.086 41.8751 44.6172C41.8751 47.254 42.9298 49.6798 44.8282 51.3673C43.2462 52.7384 41.2423 53.4767 39.0274 53.4767ZM45.8829 39.1328C47.1486 40.6094 47.8868 42.5079 47.8868 44.6172C47.8868 46.7266 47.1486 48.7306 45.8829 50.3126C44.1954 48.9415 43.3517 46.9376 43.3517 44.6172C43.3517 42.5079 44.3009 40.3985 45.8829 39.1328ZM32.1719 50.2071C30.9063 48.7306 30.168 46.7266 30.168 44.6172C30.168 42.6133 30.9063 40.6094 32.1719 39.0274C33.7539 40.3985 34.7032 42.5079 34.7032 44.6172C34.7032 46.7266 33.7539 48.836 32.1719 50.2071Z",
    fill: "url(#paint2_radial_16648_138918)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16648_138918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1093 34.8473) scale(17.4111 24.6241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16648_138918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.527 9.42926) scale(7.36404 10.4148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_16648_138918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0275 44.6172) scale(7.67231 10.8508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16648_138918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.0004,
    height: 54.0004,
    fill: "white",
    transform: "translate(0 0.953125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllRounderIcon);
export default __webpack_public_path__ + "static/media/allRounderIcon.02be0d2c962dd06380083501f1be16b9.svg";
export { ForwardRef as ReactComponent };